export const formRequestChangeFields = {
  SENDER: 'sender',
  RECEIVER: 'receiver',
  MESSAGE: 'message',
  FILES: 'files',
  FILE_IDS: 'fileIds',
  RELATED_OBJECT_ID: 'relatedObjectId',
};
